function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_1_)",
  d: "M164.593,447.652c0-4.321,1.592-8.285,3.446-11.646l0.294-0.827l62.146-106.982l1.784-3.33 c3.687-5.448,10.456-9.166,17.597-9.166c7.403,0,13.956,3.718,17.834,9.166l1.793,3.33l25.068,42.596 c5.789,10.456,19.334,14.01,29.799,7.929c7.07-3.941,10.842-11.398,10.842-19.11c0-3.609-0.611-7.265-3.139-10.734l-48.752-84.85 l-3.834-6.607c-0.434-2.396-1.375-4.846-1.375-7.457c0-2.59,0.941-5.07,1.375-7.272l3.834-6.822l85.367-148.141l3.223-5.456 c4.48-5.146,10.262-8.5,17.342-8.5c7,0,13.568,3.408,17.34,8.693c1.467,1.546,2.596,3.276,3.254,5.154l79.285,136.957 c7.844,13.957,7.844,36.776,0,50.71L391,444.236c-7.598,13.932-27.775,25.361-43.633,25.361H186.833 C174.778,469.598,164.593,459.769,164.593,447.652z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_2_)",
  d: "M335.221,52.125c0,4.351-1.453,8.562-3.432,11.924l-0.201,0.634l-62.1,107.035l-1.793,3.3 c-3.879,5.674-10.432,9.422-17.834,9.422c-7.141,0-13.91-3.748-17.597-9.422l-1.784-3.33l-25.054-42.479 c-5.981-10.509-19.381-14.148-29.875-8.113c-7.048,3.987-10.958,11.528-10.958,19.072c0,3.717,0.772,7.541,3.307,10.988 l48.731,84.734l3.654,6.8c0.657,2.202,1.538,4.63,1.538,7.272c0,2.611-0.881,5.061-1.538,7.457l-3.654,6.607L131.31,412.22 l-3.277,5.532c-4.319,5.147-10.409,8.563-17.371,8.563c-6.932,0-13.484-3.47-17.349-8.725c-1.399-1.545-2.334-3.307-3.161-5.178 L11.028,275.285c-8.037-13.934-8.037-36.753,0-50.71L108.9,55.595c7.627-13.871,27.835-25.192,43.529-25.192h161.215 C325.236,30.402,335.221,39.984,335.221,52.125z"
});

var SvgIconTokenPerl = function SvgIconTokenPerl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    enableBackground: "new 0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.1855,
    y1: 19.394,
    x2: 379.4807,
    y2: 459.8931
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#17E2CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5181FD"
    }
  })), _ref2, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.8198,
    y1: 47.6353,
    x2: 314.1051,
    y2: 488.1114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#17E2CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5181FD"
    }
  })), _ref3)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTokenPerl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Token_PERL.1c33db98.svg";
export { ForwardRef as ReactComponent };